interface ClientBehaviorsProperties {
	clientId: string;
	definition: string;
	doNotZeroOut: boolean;
	goalName: string;
	name: string;
}

export interface SaveClientBehaviorsProperties extends ClientBehaviorsProperties {
	categoryId: number;
	recordingType: number;
}

export interface UpdateClientBehaviorsProperties extends ClientBehaviorsProperties {
	id: string;
}

export interface ArchiveClientBehaviorsProperties {
	clientId: string;
	id: string;
}

export type DeleteClientBehaviorsProperties = ArchiveClientBehaviorsProperties;

export enum RecordingType {
	'duration' = 3,
	'frequency' = 1,
}

export interface RecordingTypeProperties {
	id: number;
	text: string;
}

export interface BehaviorsCategoryProperties {
	id: number;
	name: string;
}

export interface BehaviorReductionProperties {
	category: BehaviorsCategoryProperties;
	createdAt: string;
	dataToday: number;
	definition: string;
	goalName: string;
	id: string;
	isArchived: boolean;
	name: string;
	recordingType: RecordingTypeProperties;
}
export interface BehaviorDurationInstance {
	behaviorReductionId: string;
	createdAt: string;
	duration: string;
	id: string;
}
export interface BehaviorInfoProperties {
	category: BehaviorsCategoryProperties;
	count: number | null;
	duration: number | null; // seconds
	durationInstances: BehaviorDurationInstance[];
	id: string;
	name: string;
	recordingType: RecordingTypeProperties;
}
